<template>
    <div>
        <loading v-show="loading"></loading>
        <user-accessible-rooms :rooms="rooms"></user-accessible-rooms>
    </div>
</template>

<script>
import Loading from "../components/UI/Loading.vue";
import UserEdit from "../components/UserEdit.vue";
import UserAccessibleRooms from "../components/User/UserAccessibleRooms.vue";

export default {
    name: "UserAccessPage",

    components: {UserAccessibleRooms, UserEdit, Loading},

    props: ['id'],

    data: () => ({
        rooms: null,
        loading: true,
    }),

    mounted() {
        this.load();
    },

    methods: {
        load() {
            this.loading = true;
            this.$http.get('/admin/rooms/getByUserAccess/' + this.id).then((response) => {
                this.rooms = response.data.data;
                this.loading = false;
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            });
        }
    }
}
</script>

<style scoped>

</style>
